import { render, staticRenderFns } from "./nom_check.vue?vue&type=template&id=2bf367a8&scoped=true&"
import script from "./nom_check.vue?vue&type=script&lang=js&"
export * from "./nom_check.vue?vue&type=script&lang=js&"
import style0 from "./nom_check.vue?vue&type=style&index=0&id=2bf367a8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf367a8",
  null
  
)

export default component.exports